import styled, { css } from 'styled-components';
import { BKJComboBox } from '../BKJComboBox/index.js';
import { InputBaseCSS, InputErrorMessageCSS, InputLabelCSS, InputMessageCSS, InputRequiredAsteriskCSS, InputWrapperCSS, OnFocusInput, } from '../common/index.js';
export const InputLabel = styled.label `
  ${InputLabelCSS}
`;
export const ErrorMessage = styled.label `
  ${InputErrorMessageCSS}
`;
export const InputMessage = styled.label `
  ${InputMessageCSS};

  ${({ isMaxLimitReached }) => {
    if (isMaxLimitReached)
        return css `
        color: ${({ theme }) => theme.colors.ErrorDefault};
      `;
    return css ``;
}}
`;
export const RequiredAsterisk = styled(InputLabel) `
  ${InputRequiredAsteriskCSS}
`;
export const BKJPillSelectWrapper = styled.div `
  ${InputWrapperCSS};
  display: flex;
  flex-direction: column;
`;
export const TextAreaWrapper = styled.div `
  ${InputBaseCSS};
  ${({ isFocused, theme }) => {
    return isFocused
        ? css `
          ${OnFocusInput()};
        `
        : css `
          border: 1px solid ${theme.colors.Grey6};
        `;
}}
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: overlay;
  position: relative;

  ${({ isFocused, theme }) => !isFocused &&
    css `
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border-bottom: 1px solid ${theme.colors.Grey6};
      padding-bottom: 8px;
    `};
  ${({ hasValue }) => !hasValue &&
    css `
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      border-bottom: none;
    `};
  ${({ isFocused, hasValue }) => isFocused &&
    hasValue &&
    css `
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      border-bottom: none;
    `};
  ${({ isFocused, hasValue, theme }) => !isFocused &&
    !hasValue &&
    css `
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border-bottom: 1px solid ${theme.colors.Grey6};
    `};
`;
export const BKJPillSelectComboBox = styled(BKJComboBox) `
  ${({ hasValue }) => hasValue &&
    css `
      input {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
        border-top: none !important;
      }
    `};

  ${({ isFocused }) => (isFocused ? css `` : css ``)}
`;
//# sourceMappingURL=BKJPillSelect.styled.js.map